import { ResponseWithStatus } from '..';
import {
  ReportFilter,
  ResGetReportReservations,
  ResGetReportResources,
  ResGetReportUsage
} from '../types/api-types';
import { BaseOrganizationEndpoints } from './base';
import { format } from 'date-fns';

type ReportType = 'reservations' | 'usage' | 'resources';

export class Reports extends BaseOrganizationEndpoints {
  public static readonly DEFAULT_LIMIT = 20;
  public static readonly REPORTS_WITH_LIMIT = ['reservations', 'resources'];

  async usage(
    filter: ReportFilter
  ): Promise<ResponseWithStatus<ResGetReportUsage>> {
    const requestUrl = Reports.url('usage', filter);
    const result = await this.requestWithStatus<ResGetReportUsage>(
      'GET',
      requestUrl
    );
    return result;
  }

  async reservations(
    filter: ReportFilter,
    cursor: string | null = null
  ): Promise<ResponseWithStatus<ResGetReportReservations>> {
    const requestUrl = Reports.url('reservations', filter, cursor);
    const result = await this.requestWithStatus<ResGetReportReservations>(
      'GET',
      requestUrl
    );
    return result;
  }

  private static url(
    report: ReportType,
    filter: ReportFilter,
    cursor: string | null = null
  ): string {
    const limit = filter.limit ?? Reports.DEFAULT_LIMIT;
    let url =
      `/reports/${report}?` +
      `start=${encodeURIComponent(format(filter.start, 'yyyy-MM-dd'))}` +
      `&end=${encodeURIComponent(format(filter.end, 'yyyy-MM-dd'))}`;
    if (filter.search !== null) {
      url += `&search=${encodeURIComponent(filter.search)}`;
    }

    for (const id of filter.officeIds) {
      url += `&office=${encodeURIComponent(id)}`;
    }
    for (const type of filter.resourceTypes) {
      url += `&type=${encodeURIComponent(type)}`;
    }

    if (cursor !== null) {
      url += `&cursor=${encodeURIComponent(cursor)}`;
    }

    if (limit && Reports.REPORTS_WITH_LIMIT.includes(report)) {
      url += `&limit=${encodeURIComponent(limit)}`;
    }

    return url;
  }
}
